import { useLayoutEffect } from 'react';
export const useCustomSendbox = (containerRef, options) => {
    useLayoutEffect(() => {
        var _a, _b, _c, _d, _e;
        (_b = (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.querySelector("input[data-id='webchat-sendbox-input']")) === null || _b === void 0 ? void 0 : _b.setAttribute('maxlength', `${(_c = options === null || options === void 0 ? void 0 : options.maxLength) !== null && _c !== void 0 ? _c : 500}`);
        if (options === null || options === void 0 ? void 0 : options.sendButtonImgSrc) {
            const buttonEl = (_d = containerRef.current) === null || _d === void 0 ? void 0 : _d.querySelector('.webchat__send-button');
            if (buttonEl) {
                while (buttonEl.firstChild != null)
                    buttonEl.removeChild(buttonEl.firstChild);
                const img = document.createElement('IMG');
                img.setAttribute('src', options.sendButtonImgSrc);
                img.setAttribute('role', 'none');
                img.classList.add('webchat__send-icon');
                buttonEl.appendChild(img);
            }
        }
        if (options === null || options === void 0 ? void 0 : options.sendButtonLabel) {
            const buttonEl = (_e = containerRef.current) === null || _e === void 0 ? void 0 : _e.querySelector('.webchat__send-button');
            if (buttonEl) {
                const label = document.createElement('SPAN');
                label.classList.add('webchat__send-label');
                label.innerText = options === null || options === void 0 ? void 0 : options.sendButtonLabel;
                buttonEl.insertBefore(label, buttonEl.firstChild);
            }
        }
    }, [containerRef.current]);
};
//# sourceMappingURL=useCustomSendbox.js.map